/**
 * useHotspotSpeedtests — W1.3 / B1.17-Anbindung
 *
 * Holt Speedtest-Einträge vom Backend (GET /api/v2/hotspots/:id/speedtests).
 *
 * Hinweis: Das Backend-Feld `server` enthält die Geräte-Serial,
 * nicht einen Server-Namen. Im UI als "Gerät" beschriften.
 */
import { useApi } from '../../lib/use-api'
import apiClient from '../../lib/api-client'

// --- Lokale Typen ---

export type SpeedtestEntry = {
  id: string
  down_mbps: number | null
  up_mbps: number | null
  ping_ms: number | null
  /** @deprecated Dokumentierte Datenlücke, immer null — wird im UI nicht mehr angezeigt (siehe SpeedtestsTab). */
  jitter_ms: number | null
  /** Geräte-Serial (nicht Server-Name) */
  server: string | null
  taken_at: string
}

export type SpeedtestsResponse = {
  data: SpeedtestEntry[]
  meta?: {
    pagy?: {
      page: number
      pages: number
      count: number
      items: number
    }
  }
}

type UseHotspotSpeedtestsResult = {
  data: SpeedtestEntry[] | undefined
  meta: SpeedtestsResponse['meta'] | undefined
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

// --- Hook ---

export function useHotspotSpeedtests(id: string): UseHotspotSpeedtestsResult {
  const query = useApi<SpeedtestsResponse>(
    ['hotspot-speedtests', id],
    async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const client = apiClient as any
      const result = await client.GET('/api/v2/hotspots/{id}/speedtests', {
        params: {
          path: { id },
        },
      })
      return result as { data?: SpeedtestsResponse; error?: unknown }
    },
  )

  return {
    data: query.data?.data,
    meta: query.data?.meta,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => query.refetch(),
  }
}
